import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TeacherSidenavbarComponent } from '@edtech-ui/dashboard/teacher/teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { SharedModule } from '@edtech-ui/shared/shared.module';
import { SuperAdminTopNavbarComponent } from '../super-admin-top-navbar/super-admin-top-navbar.component';

@Component({
	selector: 'app-super-admin-layout',
	standalone: true,
	imports: [SharedModule,RouterOutlet,RouterModule,TeacherSidenavbarComponent,SuperAdminTopNavbarComponent],
	templateUrl: './super-admin-layout.component.html',	
	styleUrl: './super-admin-layout.component.scss'
})
export class SuperAdminLayoutComponent {

	collapsed: boolean = false;

	toggleSidenav() {
		this.collapsed = !this.collapsed;
	}
}
